/**
 * Admin Guard Component
 *
 * Prevents non-admin users from accessing admin routes.
 * Portal users are redirected to their own portal home.
 * Unknown roles are redirected to /signin.
 */

import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/auth/useAuth';
import { usePortalHome } from '@/hooks/portal/usePortalHome';

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin, isPortalUser } = useAuth();
  // Not `/portal/dashboard`: this guard is what `https://app.curaition.xyz/`
  // resolves through, so hardcoding the dashboard landed every restricted
  // member on the one page their org excluded them from (CUR-1395).
  const home = usePortalHome();

  if (isPortalUser) {
    return <Navigate to={home} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
}
